import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { Account } from "../../_app/types";
import CustomPaper from "../../_components/CustomPaper";
import IconComponent from "../../components/ui/IconComponent";
import { IconButtonPaper } from "../../_components/IconButtonPaper";
import { useAppNavigate } from "../../_hooks/use-app-navigate";
import { useTranslation } from "react-i18next";
import Text from "../../_components/Text";

interface AccountCardProps {
  account: Account;
  fullWidth?: boolean;
  activeAccount: string;
  onChangeAccount: (value: Account) => void;
}

const AccountCard = ({ account, fullWidth, activeAccount, onChangeAccount }: AccountCardProps) => {
  const theme = useTheme();
  const navigate = useAppNavigate();
  const { t } = useTranslation("account");

  return (
    <CustomPaper
      sx={{
        width: `${fullWidth ? "100% !important" : "auto"}`,
        position: "relative",
      }}
      customClass={
        activeAccount === account.id
          ? `AdronAccountBackground-${theme.palette.mode === "dark" ? "Dark" : "Light"}`
          : ""
      }
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={2}
        alignItems="center"
        onClick={() => onChangeAccount(account)}
      >
        <IconComponent iconName={account.market} size={70} type={"asBackground"} />
        <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Stack direction="column" spacing={0}>
              <Text variant="regular-semi">{account.name}</Text>
              <Text variant="regular" color={theme.myTheme.colors.foreground50}>
                {account.market}
              </Text>
            </Stack>

            <IconButtonPaper
              onClick={(e) => {
                e.stopPropagation();
                navigate.accountSettings(account.id);
              }}
              hasBorder
              outlinedCustom
            >
              <IconComponent iconName={"Settings"} hasStroke hasFill />
            </IconButtonPaper>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            {activeAccount === account.id && (
              <Stack
                sx={{ marginTop: 0, position: "absolute", right: 14, bottom: 10 }}
                direction={"row"}
                spacing={"3px"}
                alignItems={"center"}
              >
                <Text variant="regular" color={theme.myTheme.colors.foreground50}>
                  {t("active")}
                </Text>
                <IconComponent iconName={"CHECK_CIRCLED"} hasFill={false} />
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </CustomPaper>
  );
};

export default AccountCard;
